<template>
  <form-group label="Status do preço" :columns="6">
    <select v-model="filters.status" class="form-select">
      <option :value=null>Todos</option>
      <option v-for="status in productPriceStatuses" :value="status" :key="status">{{ $t(status).label }}</option>
    </select>
  </form-group>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      productPriceStatuses: [],
      filters: {
        status: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getProductPriceStatuses(this.module.type, this.module.identifier)
        .then(productStatuses => {
          this.productPriceStatuses = productStatuses
          let index = this.productPriceStatuses.indexOf('queue')

          if (index !== -1) {
            this.productPriceStatuses.splice(index, 1)
          }
        })
        .catch(() => (this.productPriceStatuses = []))
    },
    watch: {
      'filters.status' () {
        this.$emit('change', this.filters)
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PriceStatus.vue?0deb92d0